import React from 'react'
import Topheader from '../../Home/topHeader/Topheader'
import Middlebar from '../../Home/middleBar/Middlebar'
import NavMenu from '../../Home/navigationBar/NavMenu'
// import Navbar from '../../Home/navigationBar/Navbar'
import Footer from '../../Home/footer/Footer'
// import AccordionCard from './AccordionCard'
// import Accordian from '../accordion/Accordian'
import { Link } from "react-router-dom";
import AccordionCard from './AccordionCard'

export default function BSCS4Years() {
  return (
    <>
    <Topheader/>
    <Middlebar/>
    <NavMenu/>
    {/* <Navbar/> */}
      <div className="  bg-gray-200  ">
        <div className="banner">
            <img src='/BSCS4YEARS.png' 
             alt='BBA 4 YEARS'
             className='w-full sm:w-[100%] md:w-[100%] lg:w-[100%] '/>
        </div>
        <div className="content bg-gray-200 2xl:w-[80%] xl:w-[90%] lg:w-[100%] md:w-[100%] sm:w-[100%] xs:w-[200%]  justify-center justify-items-center mx-auto ">
          <div className="mx-28 2xl:w-[83%] xs:text-base">
               <h1 className='text-5xl font-bold mt-20 font-poppins text-red-800'>Course Detail</h1>

               <p className=" text-justify mt-4 mb-5 ">
               The Bachelor of Computer Science (BSCS) is a four years undergraduate degree program that
              focuses on the study of computer systems, software development, and the theoretical foundations of 
              computing. It is a comprehensive program designed to equip students with the knowledge, skills, and 
              problem-solving abilities necessary to excel in the field of computer science.
             </p>

               <p className=" text-justify mt-2 mb-5 ">
               A BSCS degree opens up a wide range of career opportunities in today's technology-driven world. Graduates often find employment as software engineers, systems analysts, data scientists, cyber security specialists, network administrators, or technology consultants. They may work in diverse industries such as technology companies, software houses, research organizations, financial institutions, healthcare organizations, or government agencies.
               </p>
               <h3 className=" font-semibold text-md">Course Structure</h3>
               <p>BSCS is a regular 4 years Degree Program (8 Semesters) with 136 Credit Hours comprises of 46 courses and a research project (6 credit hours). The minimum program duration will be 4 years; the maximum duration will be 7 years. Degree requirement for BSCS Program is minimum 2.0 CGPA</p>
               {/* <h3 className=" font-semibold text-sm">BSCS Students learn to</h3>
               <ul className='list-disc mx-7 mt-2 mb-3 text-sm'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ul> */}

               {/* <h3 className=" font-semibold text-base mt-5 ">Learning Outcomes for Bscs Students include:</h3>
               <ol className='list-decimal mx-7 mt-2 text-sm mb-5'>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
                 <li className='my-1'>Lorem ipsum dolor sit amet consectetur adipisicing elit. </li>
               </ol> */}

               <h1 className="text-2xl font-bold mt-10 font-poppins text-red-800">Eligibility Criteria</h1>
               <p className='mt-2'>
                <li className='m-1'>The minimum requirements for admission in a Bachelor degree program in Computer Science, is at least 50% marks in Intermediate (HSSC) examination with Mathematics or equivalent.</li>
                <li className='m-1'>The students who have not studied Mathematics at intermediate level have to pass deficiency courses of Mathematics (06 credits) in first two semesters.</li>
                <li className='m-1'>Applicant must clear Admission/aptitude Test of EIMS or (GAT/HAT)</li>
                <li className='m-1'>Interview conducted by the institute</li>
                <li className='m-1'>Required credentials as per HEC policy</li>
                </p> 
          </div>
          <div className='mt-10 mb-10 '>
            {/* <Accordian/> */}
            <AccordionCard />      
            </div>
        <div >
       <Link to="/ApplyNow"><button className="mx-28 w-80 h-14 rounded-md text-white bg-maroon  font-bold text-3xl">APPLYNOW</button></Link> 
      </div>
        </div>
        <div className=' pb-20'>

        </div>
      </div>
    <Footer/>  
    </>
  )
}
